import { Component, OnInit } from '@angular/core';
import { CurrencyFormatPipe } from '../../pipes/currency-format.pipe';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-home-objetivos',
  templateUrl: './home-objetivos.component.html',
  styleUrls: ['./home-objetivos.component.scss']
})
export class HomeObjetivosComponent implements OnInit {

  oficinaFacturacionList: any;
  oficina: any;
  objetivosList: any;
  currentYear = new Date().getFullYear();

  constructor(private _dashboardService: DashboardService) { }

  ngOnInit() {
    this.getData();
  }

  getData() {
    // Traemos la lista de las oficinas de facturación
    this._dashboardService.getOficinasFacturacion().subscribe(data => this.oficinaFacturacionList = data);
  }

  loadData(event: any) {
    // Cargamos la tabla con los objetivos
    console.log("loadData");
    this.oficina = event.target.value;
    this.load();
    console.log(this.objetivosList);
  }

  load() {
    this._dashboardService.getObjetivos(this.currentYear, this.oficina).subscribe(data => {this.objetivosList = data})
  }

}
